import { Button, Card, message, Typography } from 'antd'
import { useState } from 'react'
import { getAuthenticationOptions } from '~/api/passkeyApi'
import { authenticateWithPasskey } from '~/utils/passkey'

const { Text } = Typography

interface PasskeyAuthenticationProps {
  token: string
  isLoading: boolean
  onSuccess: (assertion: any) => void
}

const PasskeyAuthentication = ({
  token,
  isLoading,
  onSuccess
}: PasskeyAuthenticationProps) => {
  const [isAuthenticating, setIsAuthenticating] = useState(false)

  const handleAuthenticate = async () => {
    setIsAuthenticating(true)

    try {
      const response = await getAuthenticationOptions(token)
      const options = response.data.options

      const assertion = await authenticateWithPasskey(options)
      onSuccess(assertion)
    } catch (error: any) {
      console.error('Passkey authentication error:', error)
      message.error(error.message ?? 'Authentication failed')
    } finally {
      setIsAuthenticating(false)
    }
  }

  return (
    <div className='workstation-form'>
      <Card variant='outlined' style={{ width: 400, textAlign: 'center' }}>
        <Typography.Paragraph>
          <Text strong>Authenticate with Passkey</Text>
        </Typography.Paragraph>
        <Typography.Paragraph>
          Please authenticate using your registered passkey to access your
          workstation.
        </Typography.Paragraph>
        <Typography.Paragraph>
          <Text type='secondary'>
            Click the button below and follow your device's prompts to
            authenticate.
          </Text>
        </Typography.Paragraph>
        <Button
          type='primary'
          size='large'
          block
          onClick={() => {
            handleAuthenticate()
          }}
          loading={isLoading || isAuthenticating}
          style={{ marginTop: 16 }}
        >
          {isLoading || isAuthenticating ? 'Authenticating...' : 'Authenticate'}
        </Button>
      </Card>
    </div>
  )
}

export default PasskeyAuthentication
